import { createFeatureSelector } from '@ngrx/store';
import { MedicSearchState } from './medic-search.state';

export const getMedicSearchState = createFeatureSelector<MedicSearchState>('medicSearch');
